<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
    <div class="max-w-md w-full mx-4">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8">
        <div class="text-center mb-8">
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Schwab Options Dashboard
          </h1>
          <p class="text-gray-600 dark:text-gray-400">
            Sign in to your account
          </p>
        </div>

        <form @submit.prevent="handleLogin" class="space-y-6">
          <!-- Error message -->
          <div
            v-if="errorMessage"
            class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-600 dark:text-red-400 px-4 py-3 rounded-lg"
          >
            {{ errorMessage }}
          </div>

          <!-- Username field -->
          <div>
            <label
              for="username"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Username
            </label>
            <input
              id="username"
              v-model="credentials.username"
              type="text"
              required
              class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white focus:outline-none"
              placeholder="Enter your username"
            />
          </div>

          <!-- Password field -->
          <div>
            <label
              for="password"
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Password
            </label>
            <input
              id="password"
              v-model="credentials.password"
              type="password"
              required
              class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white focus:outline-none"
              placeholder="Enter your password"
            />
          </div>

          <!-- Submit button -->
          <button
            type="submit"
            :disabled="isLoading"
            class="w-full bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="isLoading">Signing in...</span>
            <span v-else>Sign in</span>
          </button>
        </form>

        <!-- Help text -->
        <div class="mt-6 text-center text-sm text-gray-600 dark:text-gray-400">
          <p>Don't have an account? Contact your administrator.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import apiClient from '../lib/api'
import { setToken, setUsername, isAuthenticated } from '../lib/auth'

const router = useRouter()

const credentials = ref({
  username: '',
  password: ''
})

const isLoading = ref(false)
const errorMessage = ref('')

// Redirect if already authenticated
if (isAuthenticated()) {
  router.push('/')
}

const handleLogin = async () => {
  isLoading.value = true
  errorMessage.value = ''

  try {
    const response = await apiClient.login(credentials.value)
    
    // Store token and username
    setToken(response.access_token)
    setUsername(credentials.value.username)
    
    // Redirect to positions
    router.push('/')
  } catch (error: any) {
    errorMessage.value = error.response?.data?.detail || 'Invalid username or password'
  } finally {
    isLoading.value = false
  }
}
</script>


